import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

/** Espelha o GeolocationResponse retornado pelo backend Java */
export interface GeolocationResponse {
  success: boolean;
  latitude?: number;
  longitude?: number;
  formattedAddress?: string;
  errorMessage?: string;
}

@Injectable({
  providedIn: 'root'
})
export class GeolocationService {

  private readonly baseUrl = `${environment.apiUrl}/nucon/api/geocode`;

  constructor(private http: HttpClient) {}

  /**
   * GET /nucon/api/geocode/address?address=...
   * Retorna um objeto GeolocationResponse com coordenadas e status.
   * O backend retorna 200 (OK) em caso de sucesso, 400 (Bad Request) em caso de erro.
   */
  getCoordinatesByAddress(address: string): Observable<GeolocationResponse> {
    const params = new HttpParams().set('address', address);
    return this.http.get<GeolocationResponse>(`${this.baseUrl}/address`, { params });
  }

  /**
   * GET /nucon/api/geocode/coordinates?address=...
   * Retorna um array [latitude, longitude].
   * O backend retorna 200 com o array ou 400 vazio em caso de erro.
   */
  getLatLongByAddress(address: string): Observable<number[]> {
    const params = new HttpParams().set('address', address);
    return this.http.get<number[]>(`${this.baseUrl}/coordinates`, { params });
  }
}
